module.exports = __webpack_public_path__ + "copyright.png";